<script>
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import {mapActions, mapState} from "vuex";
import { metricEventTypes, metricParents } from "@/lib";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";

export default {
  name: 'BildungsportalSponsoring',
  data: () => ({
    vereinsfoerderung: require("@/assets/keyvisual-vereinsfoerderung.webp"),
    trikotaktion: require("@/assets/keyvisual-trikotaktion.jpg"),
    equipment1: require("@/assets/new-equipment-1.png"),
    equipment2: require("@/assets/new-equipment-2.jpg"),
    interestingLinks: [
      { id: 0, title: 'NEW-Sponsoring', link: 'https://sponsoring.new.de/de' }
    ]
  }),
  components: {Breadcrumbs, RightColumnGroup},
  computed: {
    ...mapState("bildungsportal", ["sponsoringContactPersons"]),
  },
  methods: {
    ...mapActions('metrics', ['postHeartbeat']),
    ...mapActions("bildungsportal", ["loadContactPersons"]),
  },
  mounted() {
    if(!this.sponsoringContactPersons || !this.sponsoringContactPersons.length === 0) {
      this.loadContactPerson();
    }

    this.postHeartbeat({
      name: "Sponsoring",
      type: metricEventTypes.PAGE_VISIT,
      parent: metricParents.BILDUNGSPORTAL,
      data: {
        bildungsportalMetric: true,
      }
    })
  },
}
</script>

<template>
  <v-row no-gutters class="min-height-100">
    <v-col cols="12" md="8" class="new-wrapper py-10 px-5">
      <breadcrumbs />
      <div class="custom-header-text new-font-bold mb-5">Sponsoring bei der NEW – Engagement für Bildung und Gemeinschaft</div>
      <p style="white-space: pre-line">
        Die NEW engagiert sich gezielt für Schulen und Bildungseinrichtungen in der Region. Ob schulische Projekte, Bildungsinitiativen oder Veranstaltungen mit pädagogischem Mehrwert – wir fördern Initiativen, die junge Menschen stärken und Bildung erlebbar gestalten.<br><br>
        Als kommunales Unternehmen stellen wir finanzielle Mittel, Sachleistungen sowie unsere Dienstleistungen bereit. Dabei legen wir großen Wert auf eine partnerschaftliche Zusammenarbeit mit Schulen und Schulträgern sowie auf einen verantwortungsvollen und effizienten Mitteleinsatz.<br><br>
        Unser Ziel ist es, Bildung zu fördern, Gemeinschaft zu stärken und gemeinsam Perspektiven zu eröffnen.
      </p>
      <v-expansion-panels accordion>
        <v-expansion-panel>
          <v-expansion-panel-header class="primary-text font-weight-bold">NEW-Vereinsförderung</v-expansion-panel-header>
          <v-expansion-panel-content>
            Jedes Jahr im Frühjahr fällt der Startschuss für die NEW-Vereinsförderung,  mit der seit vielen Jahren das Engagement regionaler Vereine unterstützt wird. Ab diesem Zeitpunkt können sich Gemeinnützige Vereine und Organisationen aus der Region Mönchengladbach gemeinsam mit den Städten Grevenbroich, Jüchen und Korschenbroich, sowie den Regionen Heinsberg und Viersen auf der Webseite new.de/vereinsfoerderung für die Fördergelder der NEW bewerben.<br><br>
            Die NEW möchte die vielen ehrenamtlich tätigen „Helfenden Hände“, die menschliche Begegnungen möglich machen, durch die Vereinsförderung wertschätzen und unterstützen.<br>
            <br>
            An der Aktion beteiligen können sich auch Fördervereine von Schulen oder anderen Bildungseinrichtungen.
            Alle Informationen finden Sie unter <a href="https://www.new-vereinsfoerderung.de/" target="_blank">https://www.new-vereinsfoerderung.de</a>
            <v-img class="my-5" :src="vereinsfoerderung" />
            <iframe style="width: 100%; aspect-ratio: 1.78" src="https://www.youtube.com/embed/nMGAogM4TTI?si=d3HyPNwnAJOcioI6" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="primary-text font-weight-bold">NEW-Trikotaktion</v-expansion-panel-header>
          <v-expansion-panel-content>
            Auch Fördervereine von Schulen oder Bildungseinrichtungen aus dem NEW-Versorgungsgebiet können bei uns Trikotsätze, Sportbekleidung und Sporttaschen für beispielsweise Schulmannschaften auswählen und zu einem vergünstigten NEW-Preis erwerben. Die NEW-Sportkollektion der Firma JAKO kann gerne mit Schullogo oder Teamnamen bedruckt werden.<br><br>
            Alle Informationen und das Bewerbungsformular finden Sie unter <a href="https://www.new.de/nachaltigkeit/engagement/trikotaktion" target="_blank">https://www.new.de/nachaltigkeit/engagement/trikotaktion</a>
            <v-img class="my-5" :src="trikotaktion" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="primary-text font-weight-bold">Verleih von NEW-Equipment</v-expansion-panel-header>
          <v-expansion-panel-content>
            Von kleinen und großen Sonnenschirmen über Pavillon-Zelte bis hin zum NEW- Bühnenwagen – Die NEW stellt auf Anfrage und nach Verfügbarkeit ein breites Sortiment an Equipment im Rahmen eines Sachsponsorings auch Fördervereinen von Schulen oder Bildungseinrichtungen für Veranstaltungen wie z. B. Schulfeste zur Verfügung.
            Die Anfrage von -Equipment muss über unser Online-Tool erfolgen. Den Zugang finden Sie auf <a href="https://sponsoring.new.de/de/" target="_blank">https://sponsoring.new.de/de</a>
            <v-img class="my-5" :src="equipment1" />
            <v-img class="mb-5" :src="equipment2" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="primary-text font-weight-bold">Unsere Sponsoring-Richtlinien</v-expansion-panel-header>
          <v-expansion-panel-content>
            Als regionaler Versorger unterstützen wir ausschließlich eingetragene Vereine, Institutionen oder Organisationen mit lokalem Bezug, die innerhalb unseres Fördergebietes liegen (<a target="_blank" href="https://www.new.de/nachhaltigkeit/engagement">Link</a>) . Dazu zählen auch Fördervereine von Schulen oder anderen Bildungseinrichtungen.<br>
            Aktivitäten mit politischem, religiösem oder ethisch fragwürdigem Inhalt oder nicht nachhaltige Themen werden nicht unterstützt. <br>
            <br>
            Wir übernehmen keine Energiekosten sowie keine Kosten für Dienstleistungen des ÖPNV oder der Bäder.

          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="primary-text font-weight-bold">Ablauf eines NEW-Sponsorings</v-expansion-panel-header>
          <v-expansion-panel-content>
            Als kommunales Dienstleistungsunternehmen hat die NEW ein besonderes Interesse daran, gesellschaftliches und ehrenamtliches Engagement zu fördern. Über 1.000 Anfragen aus der Region erreichen uns jährlich. Um die Bearbeitung zu optimieren, ist die Anfrage ausschließlich über unser Online-Tool nötig. Mithilfe unseres vorgefertigten Fragebogens können Sie Ihr Projekt beschreiben und deutlich machen, warum wir dieses unterstützen sollten.<br>
            Eine Förderzusage erfolgt einmalig und gilt für maximal ein Jahr. Für eine erneute Förderung müssen Sie im Folgejahr einen weiteren Antrag schriftlich einreichen. Ein Sponsoring kann nur erfolgen, wenn der finanziellen Unterstützung eine angemessene werbliche Gegenleistung gegenübersteht. Ein Anspruch auf Gewährung von Zuwendungen besteht nicht. Die NEW legt Wert darauf, dass alle Fördermittel transparent und nachvollziehbar vergeben werden. Branchenexklusivität im Bereich Energieversorgung und ÖPNV muss gewährleistet sein.<br>
            Alle Informationen zu einem NEW-Sponsoring und den Zugang zu unserem Online-Tool finden Sie auf <a href="https://sponsoring.new.de/de" target="_blank">https://sponsoring.new.de/de</a>

          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="primary-text font-weight-bold">
            Unterscheidung zwischen Sponsoring und Spende
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            Sponsoring umfasst die Bereitstellung von Geld, Sachmitteln oder Dienstleistungen zur Förderung von Organisationen, Personen oder Veranstaltungen – unter vertraglicher Regelung von Leistung und Gegenleistung – mit dem Ziel, Marketing- und Kommunikationsziele zu erreichen.<br>
            Eine Spende hingegen erfolgt ohne Erwartung einer angemessenen Gegenleistung und dient der Unterstützung von Projekten, Organisationen oder Einrichtungen durch Geld oder geldwerte Sach- bzw. Dienstleistungen.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
    <v-col
        cols="12" md="4"
        class="contact_container pl-4"
    >
      <RightColumnGroup v-if="sponsoringContactPersons" :content-object="{ personsInCharge: sponsoringContactPersons, interestingLinks }" />
    </v-col>
  </v-row>
</template>

<style scoped>

</style>